export default __webpack_public_path__ + "static/end_hire_ios-f340bdfdf00be860fbfc66f940c62f67.webp";